import Footer from '../Footer'
import MaestroLogo from '../../MaestroLogo'

const Template = ({ children }) => {
  return (
    <div className='h-screen bg-background px-4'>
      <div className='absolute top-4 h-16 left-0 right-0'>
        <div className='flex items-center justify-center h-full'>
          <MaestroLogo className='h-12' />
        </div>
      </div>
      <div className='flex items-center justify-center h-full'>
        {children}
      </div>
      <div className='absolute bottom-4 h-12 left-0 right-0'>
        <Footer />
      </div>
    </div>
  )
}

export default Template;
